import { useEffect, useRef } from "react";

// Returns a ref to attach to a sentinel element near the bottom of a
// list — fires onIntersect() once it scrolls into view, which callers
// wire to React Query's fetchNextPage. rootMargin gives it a head
// start so the next page is already loading before the user hits the
// literal bottom of the page.
export default function useInfiniteScrollTrigger(onIntersect, { enabled = true } = {}) {
  const sentinelRef = useRef(null);
  const callbackRef = useRef(onIntersect);
  callbackRef.current = onIntersect;

  useEffect(() => {
    if (!enabled) return;
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) callbackRef.current();
      },
      { rootMargin: "300px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled]);

  return sentinelRef;
}
